var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 16.686791989049738 16.67954173641998",
    width: 16.686791989049738,
    height: 16.67954173641998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-163030958302112618",
    d: "M18.75 3.94 C18.75 3.94 4.07 10.08 4.07 10.08 C3.24 10.43 3.2600000000000002 11.61 4.09 11.93 C4.09 11.93 9.43 14 9.43 14 C9.69 14.1 9.9 14.31 10 14.57 C10 14.57 12.06 19.9 12.06 19.9 C12.38 20.74 13.57 20.759999999999998 13.92 19.93 C13.92 19.93 20.07 5.26 20.07 5.26 C20.4 4.43 19.57 3.6 18.75 3.94 Z",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.4574096472968283, -3.8618485953133144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.94 C18.75 3.94 4.07 10.08 4.07 10.08 C3.24 10.43 3.2600000000000002 11.61 4.09 11.93 C4.09 11.93 9.43 14 9.43 14 C9.69 14.1 9.9 14.31 10 14.57 C10 14.57 12.06 19.9 12.06 19.9 C12.38 20.74 13.57 20.759999999999998 13.92 19.93 C13.92 19.93 20.07 5.26 20.07 5.26 C20.4 4.43 19.57 3.6 18.75 3.94 Z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(240, 100, 0)"
    },
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.789f071f47136e04b246b057921c570d.svg";
export { ForwardRef as ReactComponent };